import { useTranslation } from 'react-i18next'
import { LESSON_PRICE, STARTING_CREDITS } from '@superlekcja/shared'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { AuthForm } from './AuthForm'

interface Props {
  isOpen: boolean
  onClose: () => void
  /** Temat wpisany przed logowaniem — wtedy okno zaczyna od „wygeneruj za darmo" zamiast golego „zaloguj sie". */
  pendingTopic?: string
}

/**
 * Logowanie NIE jest warunkowane zgoda na cookies analityczne.
 *
 * Wczesniej odmowa zgody zamykala okno logowania ("Logowanie wymaga cookies") — czyli dostep do
 * uslugi zalezal od zgody na cel, ktory z jej swiadczeniem nie ma nic wspolnego. Art. 7 ust. 4
 * RODO kaze to wprost uwzgledniac przy ocenie dobrowolnosci zgody, a zgoda wymuszona nie jest
 * zgoda (TASK-83). Cookie sesji jest niezbedne do wykonania uslugi zadanej przez uzytkownika
 * i zgody nie wymaga — wymagala jej wylacznie analityka, ktora dziala osobno (TASK-82).
 */
export function LoginDialog({ isOpen, onClose, pendingTopic }: Props) {
  const { t } = useTranslation()
  const topic = pendingTopic?.trim()
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[425px]"
        data-testid="auth-modal"
        aria-describedby="auth-modal-description"
      >
        <DialogHeader>
          <DialogTitle data-testid="auth-modal-header-title">
            {topic ? t('lesson-draft.title') : t('auth-modal-title')}
          </DialogTitle>
          {topic && (
            <DialogDescription asChild id="auth-modal-description">
              {/* Na tym oknie uzytkownicy odpadaja — „N lekcji za darmo" ma byc pierwsza rzecza, ktora widac. */}
              <div data-testid="auth-modal-pending-lesson" className="rounded-lg border border-primary/30 bg-primary/10 px-4 py-3 text-center">
                <span data-testid="auth-modal-free-lessons" className="block text-2xl font-bold text-primary">
                  {t('lesson-draft.free-lessons', { count: Math.floor(STARTING_CREDITS / LESSON_PRICE) })}
                </span>
                <span className="mt-1 block text-sm text-muted-foreground">{t('lesson-draft.how')}</span>
              </div>
            </DialogDescription>
          )}
        </DialogHeader>
        <AuthForm onSuccess={onClose} initialMode={topic ? 'register' : 'login'} />
      </DialogContent>
    </Dialog>
  )
}
